import { defineMessages } from 'react-intl';

export const messages: {
	tipBanner: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismissBannerLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	oauthSuccessFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	oauthSuccessFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	oauthFailFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	tipBanner: {
		id: 'search-page.quick-find.dialog.banners.github-tip.tipBanner',
		defaultMessage:
			'<b>Tip:</b> <connectLink>Connect GitHub</connectLink> to find and action on PRs, issues, and repos in your search results.',
		description:
			'Body of the GitHub tip banner shown when the user searches for GitHub-related terms. Contains a bold "Tip:" prefix and an inline "Connect GitHub" link that starts the OAuth flow.',
	},
	dismissBannerLabel: {
		id: 'search-page.quick-find.dialog.banners.github-tip.dismissBannerLabel',
		defaultMessage: 'Dismiss GitHub tip',
		description: 'Accessible label for the dismiss button of the GitHub tip banner',
	},
	oauthSuccessFlagTitle: {
		id: 'search-page.quick-find.dialog.banners.github-tip.oauthSuccessFlagTitle',
		defaultMessage: 'GitHub connected',
		description:
			'Toast flag title shown when the user successfully completes the GitHub OAuth flow started from the GitHub tip banner.',
	},
	oauthSuccessFlagDescription: {
		id: 'search-page.quick-find.dialog.banners.github-tip.oauthSuccessFlagDescription',
		defaultMessage: 'You can now find and action on PRs, commits, and repos in Rovo Search and Chat.',
		description:
			'Toast flag description shown when the user successfully completes the GitHub OAuth flow started from the GitHub tip banner.',
	},
	oauthFailFlagTitle: {
		id: 'search-page.quick-find.dialog.banners.github-tip.oauthFailFlagTitle',
		defaultMessage: 'Could not connect to GitHub',
		description:
			'Toast flag title shown when the GitHub OAuth flow started from the GitHub tip banner fails.',
	},
});
